import createCachedSelector from 're-reselect'
import { camelize } from 'util/strings'

const DEFAULT_REQUEST = { loading: false, loaded: false, error: false }

export function selectBase(state) {
  return state.request
}

export const makeSelectRequest = slice => state => {
  return selectBase(state)[slice] || DEFAULT_REQUEST
}

export const selectRequestByType = createCachedSelector(
  selectBase,
  (_state, requestType) => camelize(requestType),
  (request, requestType) => request[requestType] || DEFAULT_REQUEST
)((_state, requestType) => requestType)
